var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9168 2.73962C11.6668 -0.510376 6.3335 -0.510376 3.0835 2.73962C-0.166504 5.98962 -0.166504 11.323 3.0835 14.573C6.3335 17.823 11.5835 17.823 14.8335 14.573C18.0835 11.323 18.1668 5.98962 14.9168 2.73962ZM11.3335 12.1563L9.00016 9.82296L6.66683 12.1563L5.50016 10.9896L7.8335 8.65629L5.50016 6.32296L6.66683 5.15629L9.00016 7.48962L11.3335 5.15629L12.5002 6.32296L10.1668 8.65629L12.5002 10.9896L11.3335 12.1563Z",
    fill: "#CB2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.addf7532bc8d8d3f361f5c202740988c.svg";
export { ForwardRef as ReactComponent };